import React from "react";
import ReactApexChart from "react-apexcharts";

class JobAgeing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            series: [
                {
                    name: 'Jobs',
                    data: [
                        this.props.statistics.numberOfJobBefore7Days,
                        this.props.statistics.numberOfJobBetween7To15Days,
                        this.props.statistics.numberOfJobBetween15To30Days,
                        this.props.statistics.numberOfJobBetween30To60Days,
                        this.props.statistics.numberOfJobAfter60Days
                    ]
                },
            ],
            options: {
                chart: {
                    type: 'bar',
                    height: 250
                },
                colors: ['#0084ff'],
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        barHeight: '30%',
                        horizontal: true,
                    }
                },
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    categories: ['7 days', '7-15 days', '15-30 days', '30-60 days', '>60 days'
                    ],
                }
            },
        };
    }

    render() {
        return (
            <div id="chart">
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="bar"
                    height={250} />
            </div>
        );
    }
}

export default JobAgeing